import React from "react";
import Copyright from "./copyright";
import { getAppUrl } from "../utils/utm";

export default function Footer() {
  const appUrl = getAppUrl();
  return (
    <>
      <div className="footer bg-[#000] pt-10 md:pt-20 pb-4">
        <div className="container mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4 items-start">
            <div className="lg:col-span-2 relative">
              <div className="flex items-center space-x-2 mb-6">
                <a href="#">
                  <img
                    src="logo.png"
                    alt="Logo"
                    className="h-[40px] w-[40px] md:h-[60px] md:w-[60px]"
                  />
                </a>
                <span className="text-[18px] md:text-[24px] text-[#AFD24F] font-nomal">
                  <a href="#">
                    nudgie <span className="font-bold">AI</span>
                  </a>
                </span>
              </div>
            </div>

            <div className="relative">
              <h6 className="text-[18px] md:text-[24px] font-bold text-[#AFD24F] mb-4">
                Quick Links
              </h6>
              {[
                { label: "How it Works", href: "how-it-works" },
                { label: "Features", href: "features" },
                { label: "Getting Started", href: "gettingstarted" },
                { label: "FAQ", href: "faqs" },
                // { label: "Launch App", href: appUrl, external: true },
              ].map((item) => (
                <p key={Math.random()} className="mb-4">
                  <a
                    href={item.external ? item.href : `#${item.href}`}
                    target={item.external ? "_blank" : undefined}
                    rel={item.external ? "noopener noreferrer" : undefined}
                    className="text-[14px] md:text-[18px] font-semibold text-[#fff] hover:text-[#AFD24F]"
                  >
                    {item.label}
                  </a>
                </p>
              ))}
            </div>
            <div className="relative">
              {" "}
              <h6 className="text-[18px] md:text-[24px] font-bold text-[#AFD24F] mb-4">
                Contact
              </h6>
              <p className="flex gap-4 items-center mb-4">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="0.5"
                    y="0.5"
                    width="23"
                    height="23"
                    rx="11.5"
                    stroke="white"
                    stroke-opacity="0.4"
                  />
                  <path
                    d="M14.4695 7.5C15.14 7.5 15.785 7.765 16.2595 8.2405C16.7345 8.715 17 9.355 17 10.025V13.975C17 15.37 15.865 16.5 14.4695 16.5H9.53C8.1345 16.5 7 15.37 7 13.975V10.025C7 8.63 8.1295 7.5 9.53 7.5H14.4695ZM15.035 10.1C14.93 10.0945 14.83 10.13 14.7545 10.2L12.5 12C12.21 12.2405 11.7945 12.2405 11.5 12L9.25 10.2C9.0945 10.085 8.8795 10.1 8.75 10.235C8.615 10.37 8.6 10.585 8.7145 10.735L8.78 10.8L11.055 12.575C11.335 12.795 11.6745 12.915 12.03 12.915C12.3845 12.915 12.73 12.795 13.0095 12.575L15.265 10.77L15.305 10.73C15.4245 10.585 15.4245 10.375 15.2995 10.23C15.23 10.1555 15.1345 10.11 15.035 10.1Z"
                    fill="#8ABB01"
                  />
                </svg>

                <a
                  href="mailto:andrew@nudgieai.com"
                  className="text-[14px] md:text-[18px] font-semibold text-[#fff]"
                >
                  andrew@nudgieai.com
                </a>
              </p>
              <p className="flex gap-4 items-center mb-4"></p>
            </div>
          </div>
        </div>
      </div>
      <Copyright />
    </>
  );
}
